/**
 * SweetAlert2 等で参照する色（Tailwind の palette と一致）。
 * デザイントークンは app/assets/css/main.css の @theme を正とする。
 */
export const swalConfirmButtonColor = '#ff5a76';
export const swalCancelButtonColor = '#cccccc';
